var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 40.0001C31.0454 40.0001 39.9997 31.0458 39.9997 20.0001C39.9997 8.95437 31.0454 6.10352e-05 19.9997 6.10352e-05C8.95397 6.10352e-05 -0.000335693 8.95437 -0.000335693 20.0001C-0.000335693 31.0458 8.95397 40.0001 19.9997 40.0001Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8259 20H19.9998V40C22.3376 40 24.5811 39.5976 26.6664 38.8605L27.8259 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 34.9057C37.4245 31.2437 40 25.9229 40 20H32.1739L33.3333 34.9057Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 20V38.8605C29.1506 37.9823 31.4095 36.6277 33.3332 34.9058V20H26.6665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9564 13.0435H31.739C31.739 12.0831 30.9603 11.3044 29.9999 11.3044C29.0394 11.3044 28.2607 12.0831 28.2607 13.0435H23.0433C23.0433 14.0041 23.8799 14.7827 24.8403 14.7827H24.7824C24.7824 15.7432 25.561 16.5218 26.5216 16.5218C26.5216 17.4824 27.3001 18.2609 28.2607 18.2609H31.739C32.6995 18.2609 33.4782 17.4824 33.4782 16.5218C34.4386 16.5218 35.2173 15.7432 35.2173 14.7827H35.1594C36.1199 14.7826 36.9564 14.004 36.9564 13.0435V13.0435Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZambia);
export default __webpack_public_path__ + "static/media/zambia.d94d38638fe13805b14a343db686d29b.svg";
export { ForwardRef as ReactComponent };